import React from 'react';
import { Card } from '@/components/ui/card';

export function KpiCard({ label, value, delta, accent, icon: Icon, testid }) {
    return (
        <Card className="bg-card border-border p-4 sm:p-5 rounded-2xl shadow-card" data-testid={testid}>
            <div className="flex items-start justify-between">
                <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{label}</div>
                {Icon && (
                    <div className="h-9 w-9 rounded-lg flex items-center justify-center" style={{ background: accent?.bg || '#F1F4F8', color: accent?.color || '#0E2A47' }}>
                        <Icon className="h-4 w-4" />
                    </div>
                )}
            </div>
            <div className="mt-2 text-2xl sm:text-3xl font-display font-semibold tabular-nums text-foreground">{value}</div>
            {delta && <div className="mt-1 text-xs text-muted-foreground">{delta}</div>}
        </Card>
    );
}
